import { CloseRounded } from "@mui/icons-material";

export default function Popup({
  popupTitle,
  onClose,
  children,
  increasePopupHeight = false,
  width = `max-w-3xl`,
  subTitle = null,
}) {
  return (
    <div className="fixed select-none inset-0 flex items-center justify-center z-50">
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black opacity-50"></div>
      <div
        className={`bg-white rounded-lg p-6 z-10 ${width} w-full mx-4 sm:mx-6 md:mx-8 lg:mx-12 flex flex-col ${
          increasePopupHeight ? `h-[80vh] max-h-[90vh]` : `max-h-[90vh]`
        }`}
      >
        <div className="flex justify-between items-center flex-shrink-0 mb-4">
          <div className="flex gap-1 align-top">
            <p className="text-base md:text-lg font-semibold">{popupTitle}</p>
            {subTitle !== null && subTitle !== "" && (
              <p className="text-xs font-medium text-amber-500 bg-yellow-100 px-2 py-0.5 h-min rounded-md">
                {subTitle}
              </p>
            )}
          </div>
          {popupTitle && popupTitle?.length > 0 && onClose && (
            <button className="text-primaryRed" onClick={onClose} type="button">
              <CloseRounded />
            </button>
          )}
        </div>
        <div className="flex-1 min-h-0 overflow-y-auto">
          {children}
        </div>
      </div>
    </div>
  );
}
